module.exports = __webpack_public_path__ + "media/img/illustrations/designer-life-9b9a90a07fa43f5312018aa8df658cde.svg";